module.exports = __webpack_public_path__ + "img/terms_conditions.840204c7.svg";